import ZariTabs from './tabs'
import ZariTab from './tab'

ZariTabs.Tab = ZariTab

export default ZariTabs
